import React from 'react';

function About() {
    return (
        <div>
          <div>
            <div className="home_three_container">        
            <div>
              <div className="breadcrumbs_area">
                <div className="container">   
                  <div className="row">
                    <div className="col-12">
                      <div className="breadcrumb_content">
                        <h3>About</h3>
                        <ul>
                          <li><a href="/">home</a></li>
                          <li>About</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>         
              </div>
            </div>
            </div>
          </div>

          <section className="about_section"> 
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <figure>
                    <figcaption className="about_content">
                      <h1>Discover posts around you with real-time local experiences.</h1>
                      <p>
                        Our platform helps you connect with nearby posts, updates, and stories that
                        matter most in your area. Whether it’s events, offers, or community updates,
                        you’ll always stay informed about what’s happening around you. Designed for
                        simplicity and engagement, our app ensures a seamless way to explore and share
                        with people nearby.
                      </p>
                    </figcaption>
                  </figure>
                </div>    
              </div>  
            </div> 
          </section>
        </div>
    )
}
export default About;
